import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as React from "react";
import * as AccordionPrimitive from "@radix-ui/react-accordion";
import { ChevronDownIcon } from "lucide-react";
import { cn } from "../../lib/utils";
function Accordion({ ...props }) {
    return /*#__PURE__*/ _jsx(AccordionPrimitive.Root, {
        "data-slot": "accordion",
        ...props
    });
}
function AccordionItem({ className, ...props }) {
    return /*#__PURE__*/ _jsx(AccordionPrimitive.Item, {
        "data-slot": "accordion-item",
        className: cn('border-b last:border-b-0', className),
        ...props
    });
}
function AccordionTrigger({ className, children, chevronType = 'default', ...props }) {
    return /*#__PURE__*/ _jsx(AccordionPrimitive.Header, {
        className: "flex",
        children: /*#__PURE__*/ _jsxs(AccordionPrimitive.Trigger, {
            "data-slot": "accordion-trigger",
            className: cn('focus-visible:border-ring focus-visible:ring-ring/50 flex flex-1 items-center justify-between gap-4 rounded-md py-4 text-left text-sm font-medium transition-all outline-none hover:underlinex focus-visible:ring-[3px] disabled:pointer-events-none disabled:opacity-50', // Default chevron rotates
            '[&[data-state=open]>svg]:rotate-180', // Special_1 chevron rotates (notice the nested svg)
            '[&[data-state=open]_.special-chevron>button>svg]:rotate-180', className),
            ...props,
            children: [
                children,
                chevronType === 'default' && /*#__PURE__*/ _jsx(ChevronDownIcon, {
                    className: "text-muted-foreground pointer-events-none size-4 shrink-0 translate-y-0.5 transition-transform duration-200"
                }),
                chevronType === 'special_1' && /*#__PURE__*/ _jsx("div", {
                    className: "special-chevron",
                    children: /*#__PURE__*/ _jsx("button", {
                        className: "rounded-full bg-[#33adc1] h-8 w-8 grid place-items-center p-0",
                        children: /*#__PURE__*/ _jsxs("svg", {
                            width: "18",
                            height: "10",
                            viewBox: "0 0 18 10",
                            fill: "none",
                            xmlns: "http://www.w3.org/2000/svg",
                            className: "transition-transform duration-200",
                            children: [
                                /*#__PURE__*/ _jsx("path", {
                                    d: "M0.739319 1.18493L8.70488 8.98603C8.76302 9.0467 8.83324 9.09505 8.91121 9.12811C8.98918 9.16117 9.07324 9.17822 9.1582 9.17822C9.24317 9.17822 9.32723 9.16117 9.40519 9.12811C9.48316 9.09505 9.55339 9.0467 9.61153 8.98603L17.5771 1.18493",
                                    fill: "#33ADC1"
                                }),
                                /*#__PURE__*/ _jsx("path", {
                                    d: "M0.739319 1.18493L8.70488 8.98603C8.76302 9.0467 8.83324 9.09505 8.91121 9.12811C8.98918 9.16117 9.07324 9.17822 9.1582 9.17822C9.24317 9.17822 9.32723 9.16117 9.40519 9.12811C9.48316 9.09505 9.55339 9.0467 9.61153 8.98603L17.5771 1.18493",
                                    stroke: "white",
                                    strokeWidth: "0.79933",
                                    strokeLinecap: "round",
                                    strokeLinejoin: "round"
                                })
                            ]
                        })
                    })
                })
            ]
        })
    });
}
function AccordionContent({ className, children, ...props }) {
    return /*#__PURE__*/ _jsx(AccordionPrimitive.Content, {
        "data-slot": "accordion-content",
        className: "data-[state=closed]:animate-accordion-up data-[state=open]:animate-accordion-down overflow-hidden text-sm",
        ...props,
        children: /*#__PURE__*/ _jsx("div", {
            className: cn('pt-0 pb-4', className),
            children: children
        })
    });
}
const AccordionHeader = AccordionPrimitive.Header;
export { Accordion, AccordionItem, AccordionTrigger, AccordionContent, AccordionHeader };

//# sourceMappingURL=Accordion.js.map